var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCivicLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 220,
    viewBox: "0 0 690 220",
    width: 690,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m131.993 93.3206c0-12.2375-9.92-22.1572-22.158-22.1572-12.2378 0-22.1587 9.9196-22.1587 22.1572 0 8.5624 4.8655 15.9774 11.9759 19.6654l-8.2122 35.51h36.789l-8.211-35.51c7.109-3.688 11.975-11.103 11.975-19.6654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.503 137.755c-4.303 33.412-32.913 59.319-67.479 59.319h-38.3784c-37.5285 0-68.06-30.53-68.06-68.057v-38.3753c0-37.5265 30.5315-68.0566 68.06-68.0566h38.3784c34.566 0 63.175 25.9075 67.479 59.3196h22.737c-4.411-45.8955-43.182-81.9047-90.216-81.9047h-38.3784c-49.9822 0-90.6456 40.6621-90.6456 90.6417v38.3753c0 49.98 40.6635 90.642 90.6456 90.642h38.3784c47.034 0 85.805-36.01 90.216-81.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.498 62.3014h-22.616v105.5166h22.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.076 143.111-28.776-80.8096h-24.288l38.953 105.5166h27.403l38.952-105.5166h-23.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.447 62.3014h-22.614v105.5166h22.614z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m666.082 131.297c-3.08 11.557-12.203 18.422-24.68 18.422-17.539 0-29.325-13.846-29.325-34.454 0-20.8532 11.786-34.864 29.325-34.864 12.83 0 21.604 6.5374 24.873 18.4217h23.717c-4.842-23.9981-22.316-37.7521-48.18-37.7521-15.655 0-28.953 5.1501-38.459 14.8939-9.49 9.7275-14.506 23.3173-14.506 39.3005 0 16.152 4.91 29.724 14.198 39.249 9.273 9.509 22.466 14.535 38.152 14.535 26.061 0 44.193-14.098 48.803-37.752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.531 131.297c-3.08 11.557-12.203 18.422-24.681 18.422-17.54 0-29.324-13.846-29.324-34.454 0-20.8532 11.784-34.864 29.324-34.864 12.831 0 21.605 6.5374 24.874 18.4217h23.716c-4.843-23.9981-22.316-37.7521-48.179-37.7521-15.655 0-28.953 5.1501-38.46 14.8939-9.49 9.7275-14.506 23.3173-14.506 39.3005 0 16.152 4.91 29.724 14.198 39.249 9.273 9.509 22.466 14.535 38.153 14.535 26.062 0 44.194-14.098 48.802-37.752z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivicLogoWhite);
export default __webpack_public_path__ + "static/media/civic-logo-white.09541efec382ee713f04d5e05c181165.svg";
export { ForwardRef as ReactComponent };